import { useRef } from 'react';

import { Toggle } from '@opendoor/bricks-next';

import { useLanguagePreference } from 'helpers/useLanguagePreference';

export const LanguageToggle = () => {
  const { defaultToSpanish, loading, toggleLanguage } = useLanguagePreference();

  const hasInteracted = useRef(false);

  const handleToggle = () => {
    if (!hasInteracted.current) {
      hasInteracted.current = true;
      return; // skip the first toggle caused by initial state
    }

    toggleLanguage();
  };

  if (loading) return null;

  return (
    <Toggle
      size="large"
      onCheckedChange={handleToggle}
      defaultChecked={defaultToSpanish}
      leftLabel="English"
      rightLabel="Spanish"
    />
  );
};
